import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  Type,
  OnDestroy,
} from '@angular/core';
import {
  IconDynamicColors,
  IconDynamicData,
  IconDynamicHeadsetComponent,
  IconDynamicHeartInHandComponent,
  IconDynamicStethoscopeComponent,
  OmniAnalyticsService,
  getConversationType,
} from '@cigna/omni/shared';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';
import { ConversationDTO } from '@cigna/vampire-dto';
import { FeatureTogglesFacade } from '@cigna/features';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cigna-omni-conversation-summary-card',
  templateUrl: './omni-conversation-summary-card.component.html',
  styleUrls: ['./omni-conversation-summary-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmniConversationSummaryCardComponent implements OnDestroy {
  @Input()
  public body?: string;

  @Input()
  public chevronColor: IconDynamicColors;

  @Input()
  public conversationId: string;

  @Input()
  public icon: Type<
    | IconDynamicHeadsetComponent
    | IconDynamicHeartInHandComponent
    | IconDynamicStethoscopeComponent
  >;

  @Input()
  public iconColors: IconDynamicColors;

  @Input()
  public iconData?: IconDynamicData;

  @Input()
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public newMessages: boolean;

  @Input()
  public subject: string;

  @Input()
  public isClosed: boolean;

  @Input()
  public date: string;

  @Input()
  public state: string;

  @Input()
  public context: ConversationDTO['context'];

  @Output()
  public interaction: EventEmitter<void> = new EventEmitter();
  isEvernorth: boolean;
  checkEvernorthMember: Subscription;
  public shouldEnablePreChatWelcome$ = this.featureToggleFacade.featuresEnabled(
    ['enableNewPreChatWelcome'],
  );

  public onClick(): void {
    this.conversationsFacade.setConversationId(this.conversationId);
    this.chatFacade.openDialog();

    this.analytics.track('viewChat', {
      newMessages: this.newMessages,
      chatState: this.state,
    });

    if (this.newMessages && getConversationType(this.context) === 'DM') {
      this.analytics.trackEvent('viewNewMessage', {
        chatContext: this.context,
      });
    }

    if (this.isEvernorth) {
      const linkText = 'Open Conversation History Item';
      this.analytics.trackEvent('chatConversationHistoryView', { linkText });
    }
  }

  constructor(
    private chatFacade: OmniChatFacade,
    private conversationsFacade: OmniConversationsFacade,
    private analytics: OmniAnalyticsService,
    private featureToggleFacade: FeatureTogglesFacade,
  ) {
    this.checkEvernorthMember = this.featureToggleFacade
      .featuresEnabled(['isEvernorthEnabled'])
      .subscribe((isEvm) => {
        this.isEvernorth = isEvm;
      });
  }

  ngOnDestroy() {
    this.checkEvernorthMember.unsubscribe();
  }
}
